import { Stands } from '../Stands';
import { AppConfigs } from './AppConfigs/AppConfigs';

export const services = {
	clientAuthApi: 'clientAuthApi',
	clientAppFormApi: 'clientAppFormApi',
	clientOrderApi: 'clientOrderApi',
	clientProfileApi: 'clientProfileApi',
	fileLoadApi: 'fileLoadApi',
};

const gateway = {
	[Stands.test]: 'https://api.efrtest.ru',
	[Stands.cert]: 'https://api.efrcert.ru',
	[Stands.prod]: 'https://api.efr.ru',
};

export const efrT2BotPaths = [];

export const appEfrT2Config = new AppConfigs<typeof services>({
	servicesHosts: Object.fromEntries(
		Object.keys(services).map((key) => [key, gateway]),
	) as Record<keyof typeof services, typeof gateway>,
	appHostName: 'efrT2',
});
export type AppEfrT2Config = AppConfigs<typeof services>;
